import { useMutation } from '@apollo/client'
import { createInitiative as createInitiativeGql }
   from 'src/graphql/mutations/createInitiative.gql'

const useCreateInitiative = (mutationHookOptions) => {
   const [createInitiative, { called, client, data, error, loading }] = useMutation(
      createInitiativeGql,
      { refetchQueries: ['getInitiativeList'], ...mutationHookOptions }
   )

   const wrappedMutationFn = (input, mutationFnOptions) => createInitiative({
      variables: { input },
      ...mutationFnOptions
   })

   return {
      createInitiative: wrappedMutationFn,
      called,
      client,
      error,
      mutating: loading,
      result: data
   }
}

export default useCreateInitiative
